module.exports = __webpack_public_path__ + "static/media/mercado-modelo-cartao-acesso-768x591.63ccb05f.jpg";